<app-breadcrumb></app-breadcrumb>
<div class="notifications-page" style="margin-top: 10px;">
  @if (isloading) {
    <div class="blur-overlay">
      <mat-progress-spinner class="mat-spinner-color" mode="indeterminate"></mat-progress-spinner>
    </div>
  }

  <div class="container-fluid mt-3">
    <div class="row">
      <!-- LEFT SIDE: Notification Menu Panel -->
      <div [ngClass]="{'col-lg-12': !notificationSelected, 'col-lg-8': notificationSelected}">
        <div class="notification-menu-card p-3 border rounded">
          <div class="notification-header-section">
            <div class="notification-container" style="margin-top: 10px;">
              <span>Notifications</span>
              <div class="read-container">
                <div class="mark-read" (click)="markAsRead($event)">
                  Mark All As Read
                </div>
                <div>
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" [(ngModel)]="showUnreadOnly"
                      (change)="toggleUnreadOnly()" style="position: sticky;" />
                      Show Unread
                    </label>
                  </div>
                </div>
              </div>
              <hr style="border: 1px solid #333;" />
              <!-- Notification Types Filter -->
              <div class="notification-types-bar d-flex flex-wrap">
                <div class="type-link" (click)="onNotificationTypeClick('All')" [class.active]="!selectedType">
                  All
                </div>
                @for (item of tags | keyvalue; track item) {
                  <div class="type-link" (click)="onNotificationTypeClick(item.key)"
                    [class.active]="selectedType === item.key">
                    {{ item.key }}
                  </div>
                }
              </div>
            </div>

            <!-- No notifications case -->
            @if (notificationsError || (notifications && (notifications | keyvalue).length === 0)) {
              <div
                class="container">
                <div class="row justify-content-center">
                  <div class="col-12 text-center empty-notifications">
                    <i class="fas fa-bell fa-5x empty-notification-icon"></i>
                    <div class="empty-notification-text">
                      No notifications found for the selected type.
                    </div>
                  </div>
                </div>
              </div>
            }

            <!-- Notification Cards with Pagination -->
            @if (!notificationsError && (notifications | json) != '{}') {
              <div>
                <div infinite-scroll [infiniteScrollDistance]="distance" [infiniteScrollThrottle]="throttle"
                  (scrolled)="onScroll()">
                  @for (notification of paginatedNotifications | keyvalue : orderOriginal; track notification) {
                    <div class="notifications-list"
                      >
                      <div class="date">{{ notification.key }}</div>
                      @for (item of notification.value; track item; let i = $index) {
                        <div>
              <div class="notification-card" (click)="selectNotification(item)" [ngClass]="{
                      'notification-read': item.is_read,
                      'notification-unread': !item.is_read,
                      'notification-hover': hoverActive && i === itemIndex && itemKey === notification.key,
                      'notification-selected': selectedNotification?.id === item?.id
                    }" (mouseover)="hoverActive = true; itemIndex = i; itemKey = notification.key"
                            (mouseout)="hoverActive = false; itemIndex = -1; itemKey = ''">
                            <div class="row d-flex align-items-center">
                              <div class="col-image">
                                <div class="image">
                          <p class="image-text" matTooltip="{{ getNotificationAvatarTooltip(item) }}" [ngClass]="{
                              'font-normal': !getNotificationActorName(item),
                              'font-weight-normal': !!getNotificationActorName(item)
                            }">
                                    {{
                                    getNotificationAvatarText(item)
                                    }}
                                  </p>
                                </div>
                              </div>
                              <div class="notification-text d-flex justify-content-between align-items-center">
                                <div class="mr-2 flex-grow-1">
                                  <div class="notification-header">{{ item.title }}</div>
                                  @if (!item.url) {
                                    <div class="notification">
                                      {{ getCleanMessage(item.message) }}
                                    </div>
                                  }
                                  @if (item.url) {
                                    <div class="notification">
                                      <a
                                        href="javascript:void(0)"
                                        (click)="openNotificationLink($event, item)"
                                        >
                                        {{ getCleanMessage(item.message) }}
                                      </a>
                                    </div>
                                  }
                                </div>
                                <div class="notification-time-display">
                                  @if (item.created_datetime || item.created_date || item.timestamp) {
                                    <span class="time-text">
                                      {{ getFormattedTime(item.created_datetime || item.created_date || item.timestamp) }}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <!-- With Font Awesome Icons -->
                @if (totalPages > 1) {
                  <div class="pagination-container d-flex justify-content-between align-items-center">
                    <div class="pagination-info">
                      <!--<span></span>-->
                      <button class="btn btn-sm " (click)="previousPage()" [disabled]="currentPage === 1">
                        <i class="fa-solid fa-arrow-left" style="font-size: 30px;"></i> </button>
                      </div>
                      <div class="pagination-controls">
                        <span class="page-indicator">
                          {{ (currentPage - 1) * pageSize + 1 }}-{{ getEndIndex() }} of {{ totalItems }}
                        </span>
                        <button class="btn btn-sm " style="border: 1px solid transparent;" (click)="nextPage()"
                          [disabled]="currentPage === totalPages">
                          <i class="fa-solid fa-arrow-right" style="font-size: 30px;"></i> </button>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>

            <!-- RIGHT SIDE: Notification Details Panel -->
            @if (notificationSelected) {
              <div class="col-lg-4">
                <div class="notification-details p-4 border rounded">
                  <div style="display: flex;justify-content: space-between;">
                    <div class="mb-3">
                      <span class="tab-item active fw-bold me-2">
                        {{ getNotificationHeading(selectedNotification) }}
                      </span>
                    </div>
                    <!-- Replace close button with user image -->
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="user-image-container">
                        <div class="user-image">
                  <p class="image-text" matTooltip="{{ getNotificationAvatarTooltip(selectedNotification) }}" [ngClass]="{
              'font-normal': !getNotificationActorName(selectedNotification),
              'font-weight-normal': !!getNotificationActorName(selectedNotification)
            }">
                            {{
                            getNotificationAvatarText(selectedNotification)
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mb-2 boldnes">
                    <span class="fw-medium boldnes">Event type :</span>
                    {{
                    getNotificationEventType(selectedNotification)
                    }}
                  </div>
                  <div class="mb-2 boldnes">
                    <span class="fw-medium boldnes">Event name :</span>
                    {{ selectedNotification.cleanedMessage }}
                  </div>
                  <div class="mb-2 boldnes">
                    <span class="fw-medium boldnes">Created By :</span>
                    {{ getNotificationCreatedBy(selectedNotification) }}
                  </div>
                  <div class="mb-2 boldnes">
                    <span class="fw-medium boldnes">Created Date & Time :</span>
                    {{ getFormattedDateTime(selectedNotification.created_datetime) }}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
